import * as React from "react";
import { forwardRef } from "react";
const SvgChevronDown = (props, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M18 10.41L16.59 9L12 13.58L7.41 9L6 10.41L12 16.41L18 10.41Z", fill: "currentcolor" }));
const ForwardRef = forwardRef(SvgChevronDown);
export default ForwardRef;
